/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PolicyManager } from '../models/policy-manager';
@Injectable({
  providedIn: 'root',
})
class PolicyService extends __BaseService {
  static readonly getPoliciesByEntityNameOrBlockedOnlyPath = '/policy/list';
  static readonly flushPolicyPath = '/policy/{conical}/flush';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `PolicyService.GetPoliciesByEntityNameOrBlockedOnlyParams` containing the following parameters:
   *
   * - `entityName`:
   *
   * - `blockedOnly`:
   *
   * @return get array of policies to modify
   */
  getPoliciesByEntityNameOrBlockedOnlyResponse(params: PolicyService.GetPoliciesByEntityNameOrBlockedOnlyParams): __Observable<__StrictHttpResponse<Array<PolicyManager>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.entityName != null) __params = __params.set('entityName', params.entityName.toString());
    if (params.blockedOnly != null) __params = __params.set('blockedOnly', params.blockedOnly.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/policy/list`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PolicyManager>>;
      })
    );
  }
  /**
   * @param params The `PolicyService.GetPoliciesByEntityNameOrBlockedOnlyParams` containing the following parameters:
   *
   * - `entityName`:
   *
   * - `blockedOnly`:
   *
   * @return get array of policies to modify
   */
  getPoliciesByEntityNameOrBlockedOnly(params: PolicyService.GetPoliciesByEntityNameOrBlockedOnlyParams): __Observable<Array<PolicyManager>> {
    return this.getPoliciesByEntityNameOrBlockedOnlyResponse(params).pipe(
      __map(_r => _r.body as Array<PolicyManager>)
    );
  }

  /**
   * @param conical undefined
   * @return a boolean which is true if success.
   */
  flushPolicyResponse(conical: string): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/policy/${encodeURIComponent(String(conical))}/flush`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param conical undefined
   * @return a boolean which is true if success.
   */
  flushPolicy(conical: string): __Observable<boolean> {
    return this.flushPolicyResponse(conical).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module PolicyService {

  /**
   * Parameters for getPoliciesByEntityNameOrBlockedOnly
   */
  export interface GetPoliciesByEntityNameOrBlockedOnlyParams {
    entityName?: string;
    blockedOnly?: boolean;
  }
}

export { PolicyService }
